import { TwitchStoreState } from './types/TwitchStoreState';

export const DEFAULT_VOLUME = 0.75;

export const defaultState = (): TwitchStoreState => ({
	isEnabled: false,
	isStreaming: false,
	defaultTimeSeconds: 20,

	voices: undefined,
	selectedVoiceId: undefined,
	voicePreview: undefined,
	voicePreviewProgress: 0,
	volume: DEFAULT_VOLUME,

	broadcaster: undefined,
	isProcessing: false,

	error: undefined,
	liveStatusCheckIntervalId: undefined,
});
